import { c as _c } from "react/compiler-runtime";
import React from "react";
import DropListItemRateGive from "@/components/drops/view/item/rate/give/DropListItemRateGive";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { ApiDropType } from "@/generated/models/ApiDropType";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
interface WaveDropActionsRateProps {
  readonly drop: ApiDrop;
  readonly onRated?: (() => void) | undefined;
  readonly isMobile?: boolean | undefined;
}
const WaveDropActionsRate: React.FC<WaveDropActionsRateProps> = t0 => {
  const $ = _c(12);
  const {
    drop,
    onRated,
    isMobile: t1
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  const {
    canShowVote
  } = useDropInteractionRules(drop);
  const {
    isMemesWave
  } = useSeizeSettings();
  let t2;
  if ($[0] !== drop.drop_type || $[1] !== drop.wave?.id || $[2] !== isMemesWave) {
    t2 = drop.drop_type === ApiDropType.Chat || drop.drop_type === ApiDropType.Participatory && isMemesWave(drop.wave?.id);
    $[0] = drop.drop_type;
    $[1] = drop.wave?.id;
    $[2] = isMemesWave;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const shouldHideClap = t2;
  let t3;
  if ($[4] !== canShowVote || $[5] !== drop || $[6] !== isMobile || $[7] !== onRated || $[8] !== shouldHideClap) {
    t3 = canShowVote && !shouldHideClap && <div className={isMobile ? "tw-p-4 tw-rounded-xl tw-inline-flex" : ""}><DropListItemRateGive drop={drop} onRated={onRated} isMobile={isMobile} /></div>;
    $[4] = canShowVote;
    $[5] = drop;
    $[6] = isMobile;
    $[7] = onRated;
    $[8] = shouldHideClap;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <>{t3}</>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default WaveDropActionsRate;